import { all } from "redux-saga/effects";

import authSaga from "./auth/saga";
import layoutSaga from "./layout/saga";
import languageSaga from "./language/saga";
import countrySaga from "./country/saga";
import usersSaga from "./users/saga";
import productsSaga from "./products/saga";
import expeditionsSaga from "./expeditions/saga";
import requestsSaga from "./requests/saga";
import affiliatesSaga from "./affiliates/saga";
import ordersSaga from "./orders/saga";
import shippingsSaga from "./shippings/saga";
import invoicesSaga from "./invoices/saga";
import analyticsSaga from "./analytics/saga";
import packagesSaga from "./pack/saga";
import logsSaga from "./logs/saga";
import notificationsSaga from "./notifications/saga";
import integrationSaga from "./integration/saga";
import transferOrdersSaga from "./transferOrders/saga";
import boutiqueSaga from "./boutique/saga";

export default function* rootSaga() {
  yield all([
    authSaga(),
    layoutSaga(),
    languageSaga(),
    productsSaga(),
    countrySaga(),
    expeditionsSaga(),
    usersSaga(),
    requestsSaga(),
    affiliatesSaga(),
    ordersSaga(),
    shippingsSaga(),
    invoicesSaga(),
    analyticsSaga(),
    packagesSaga(),
    logsSaga(),
    notificationsSaga(),
    integrationSaga(),
    transferOrdersSaga(),
    boutiqueSaga(),
  ]);
}
